/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2022 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
import { getProvider } from "./provider.js";
import { Algorithms, } from "./hmactypes.js";
import ChunkHmac from "./hmac/chunkhmac.js";
export { Algorithms, };
/**
 * Return an object that can process hmac in chunks
 */
export const hmac = (algorithm, key) => {
    const hmacProvider = getProvider().hmacProvider;
    if (hmacProvider.hmac) {
        return hmacProvider.hmac(algorithm, key);
    }
    return Promise.resolve(new ChunkHmac(algorithm, key));
};
/**
 * Fallback implementation of HMAC using regular digest functions
 */
const fallbackHmacImmediate = async (algorithm, data, key) => {
    // eslint-disable-next-line no-use-before-define
    const chunkHmac = await hmac(algorithm, key);
    return chunkHmac.hmac(data);
};
/**
 * Compute a HMAC on a single buffer
 */
export const hmacImmediate = (algorithm, data, key) => {
    const hmacProvider = getProvider().hmacProvider;
    if (hmacProvider.hmacImmediate) {
        return hmacProvider.hmacImmediate(algorithm, data, key);
    }
    return fallbackHmacImmediate(algorithm, data, key);
};
